<template>
  <div class="d-flex flex-column-fluid">
    <!--begin::Container-->
    <div class="container">
      <!--      <span style="position: absolute; top:-70px; right:0px; z-index: 10000">-->
      <!--        <button-->
      <!--          ref="refresh"-->
      <!--          :disabled="isBusy"-->
      <!--          class="btn btn-light font-weight-bolder font-size-sm mx-1"-->
      <!--          @click="submitsearch"-->
      <!--        >-->
      <!--          <i class="flaticon2-refresh"></i>Refresh-->
      <!--        </button>-->
      <!--      </span>-->
      <div class="row">
        <div class="col-12">
          <div class="card card-custom card-stretch gutter-b">
            <div class="card-header border-0 py-5">
              <div class="card-toolbar" style="width: 100%">

                <b-form-input v-model="search.Username" class="mx-1 col-12 col-md-3" placeholder="Username" type="text"></b-form-input>
                <button ref="refresh" :disabled="isBusy" class="btn btn-light font-weight-bolder font-size-sm mx-1" @click="submitsearch">
                  Search
                </button>
              </div>
            </div>
            <div class="card-body pt-0 pb-3">
              <div class="table-responsive">
                <table class="table table-head-custom table-head-bg table-borderless table-vertical-center table-hover">
                  <thead>
                  <tr class="text-uppercase">
                    <th class="pl-7">
                      <span class="text-dark-75">Username</span>
                    </th>
                    <th class="text-dark-75">Business Name</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in items.data" :key="item.UserId">
                    <!--              <tr>-->
                    <td class="py-2">
                      <div class="d-flex align-items-center">
                        <router-link :to="{ name: 'easyreceipt-adminusers-details', params: { propdata: item }}">
                          <button
                              type="button"
                              class="btn btn-block btn-sm btn-link font-weight-bolder text-uppercase"
                          >
                            {{ item.Username }}
                          </button>
                        </router-link>
                      </div>
                    </td>
                    <td>
                    <span class="d-block">{{
                        item.BusinessName
                                          }}</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!--end::Table-->
            </div>
          </div>
        </div>
      </div>
      <!--end::Row-->

      <!--begin::Pagination-->
      <div class="card card-custom">
        <div class="card-body pt-0 pb-2">
          <Paginator v-bind:currentPage="search.currentPage" v-bind:rowsPerPage="search.rowsPerPage" v-bind:totalRows="items.totalRows" @update-currentpage="
              value => {
                search.currentPage = value;
                this.submitsearch();
              }
            " @update-pagesize="
              value => {
                search.currentPage = 1;
                setPageSize(value);
              }
            "/>
        </div>
      </div>
      <!--end::Pagination-->
    </div>
    <!--end::Container-->
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/view/pages/easyreceipt/api";
import Vue from "vue";
import vueNumeralFilterInstaller from "vue-numeral-filter";
import Paginator from "@/view/content/widgets/paginator2.vue";
import numeral from "numeral";
import numFormat from "vue-filter-number-format";

Vue.use(vueNumeralFilterInstaller);
Vue.use(require("vue-moment"));
Vue.filter("numFormat", numFormat(numeral));

export default {
  components: {Paginator},
  data() {
    return {
      isBusy: false,
      filters: {},
      options: {
        Users: []
      },
      search: {
        currentPage: 1,
        rowsPerPage: 6,
        Username: "",
      },
      items: {
        data: [],
        totalRows: 0,
        indexStart: 0
      }
    };
  },
  computed: {
    ...mapGetters(["layoutConfig", "currentUser"]),
    config() {
      return this.layoutConfig();
    },
    currentPage() {
      return this.search.currentPage;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.setBreadcrumbs("Users");
      this.submitsearch();
    },
    setBreadcrumbs(value) {
      let payload = [
        {
          title: "Easy Receipt",
          route: "/easyreceipt"
        }];
      payload.push({title: value});
      this.$store.dispatch(SET_BREADCRUMB, payload);
    },
    setPageSize(value) {
      this.search.rowsPerPage = value;
      this.submitsearch();
    },
    submitsearch() {
      var self = this;
      self.isBusy = true;
      return new Promise(resolve => {
        let param = {
          currentPage: self.search.currentPage,
          rowsPerPage: self.search.rowsPerPage,
          Username: self.search.Username
        };
        this.$gtag.event("admin_user_search", {
          search_term: JSON.stringify(param)
        });
        ApiService.get("user/search", param)
                  .then(({data}) => {
                    self.items.data = data.Items;
                    self.items.totalRows = data.TotalRows;
                    self.items.indexStart = (self.search.currentPage - 1) * self.search.rowsPerPage;
                    self.isBusy = false;

                    window.scrollTo(0, 0);
                    resolve(data);
                    return data;
                  })
                  .catch(() => {
                    self.items.data = [];
                    self.items.totalRows = 0;
                    self.isBusy = false;
                    window.scrollTo(0, 0);
                  });
      });
    }
  },
  watch: {
    currentPage(newValue, oldValue) {
      if (newValue != oldValue) {
        this.submitsearch();
      }
    }
  }
};
</script>
